import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { map } from 'rxjs';

import { MembersService } from '@api';
import { TranslateService } from '@ngx-translate/core';

import { DefaultModule } from '@module';

import { BaseDropdown, LibDropdownModule } from 'pn-core-code';

export interface translationsDto {
  id: string;
  name: string;
}

@Component({
  selector: 'shared-member-dropdown',
  standalone: true,
  imports: [DefaultModule, LibDropdownModule],
  templateUrl: '/node_modules/pn-core-code/src/base/base-dropdown/base-dropdown.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberDropdownComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberDropdownComponent extends BaseDropdown<translationsDto> {
  @Input() memberId: string | undefined;

  override inputChanges = ['memberId'];
  currentLang: string;

  constructor(
    protected override cdr: ChangeDetectorRef,
    protected override translateService: TranslateService,
    private membersService: MembersService,
  ) {
    super(cdr, translateService);
    this.translateService.onLangChange.subscribe((t) => {
      console.log('translateService', t);
      this.currentLang = t.lang;
      this.apiOptionListGet$();
    });
  }

  override ngOnInit() {
    this.currentLang = this.translateService.currentLang;
    super.ngOnInit();
  }

  protected override apiOptionListGet$() {
    return this.membersService.membersDropdownGet$(1, 9999).pipe(
      map((res) => {
        let translationsList: any[] = [];
        for (const data of res) {
            translationsList.push({
              id: data.id,
              name: data.firstname + ' ' + data.lastname,
            });
        }
        return translationsList;
      }),
    );
  }
}
